
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listen",
      function () {
        return require("private-next-pages/listen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listen"])
      });
    }
  